import CheckBoxList from './CheckBoxList'

const FeatureSetCheckboxList = ({featureSets, setFeatureSets}) => {

    return (
        <CheckBoxList list={featureSets} setList={setFeatureSets} labelKey={'name'} />
    )
}

export default FeatureSetCheckboxList